import React from 'react';
import ApiPage from './ApiPage';

const PrivacyPolicy = () => {
  return (
    <ApiPage
      slug="privacy-policy"
      fallbackTitle="Privacy Policy"
      seoTitle="Privacy Policy | WealthDost"
      seoDescription="Read the WealthDost privacy policy to understand how we collect, use, and protect your information."
      seoPath="/privacy"
    />
  );
};

export default PrivacyPolicy;
